export const viewConstants = {
    IS_LOADING : 'IS_LOADING',
    IS_NOT_LOADING : 'IS_NOT_LOADING',
    SET_MAIN_TITLE: 'SET_MAIN_TITLE',
    SET_BREADCRUMB: 'SET_BREADCRUMB',
    UNAUTHORIZED: 'UNAUTHORIZED',

    SET_CONTEXT_DROP_MENU: 'SET_CONTEXT_DROP_MENU'
};